import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "landing",
  class: "py-4"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "welcome" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "text-v-h3" }, "Välkommen till vår demo sida!", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Det här är en demo sida för \"Mina sidor\" som är under utveckling. Vi vill gärna ha dina synpunkter och idéer. Maila till "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:rikard@westro.se" }, "rikard@westro.se"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", { class: "text-v-h3" }, "Vilket företag vill du företräda?", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, " På den här sidan ser du vilka företag du kan företräda, som firmatecknare eller som ombud. Välj här vem du vill företräda idag. ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", { class: "text-v-h3" }, "Var hämtas informationen ifrån?", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, " Uppgifterna om dig som privatperson hämtar vi från folkbokföringsdatabasen hos Skatteverket. För näringsidkare eller förening hämtar vi motsvarande uppgifter från Bolagsverkets register. ", -1)


import { useAuthStore } from '@/stores/authStore'
import companieswithAccess from '@/components/companies-withAccess.vue'
import companieswithoutAccess from '@/components/companies-withOutAccess.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LandingView',
  props: {
  textClass: {
    type: Object
  },
  columnSizes: {
    type: Object
  }
},
  setup(__props) {

const AuthStore = useAuthStore()

const props = __props

document.title = 'Välkommen'

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", {
      class: _normalizeClass(__props.textClass?.h1)
    }, "Välkommen " + _toDisplayString(_unref(AuthStore).getFirstName) + "!", 3),
    _createElementVNode("h2", {
      class: _normalizeClass([__props.textClass?.h2, "pb-6"])
    }, " Vem eller vad vill du företräda? ", 2),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: __props.columnSizes?.[0],
          class: "pr-8"
        }, {
          default: _withCtx(() => [
            (_unref(AuthStore).isAuthenticated &&
      _unref(AuthStore).permissionsLoadStatus === 'loading'
      )
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_v_container, {
                    fluid: "",
                    class: "py-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _createTextVNode(" Vi hämtar nu information kring vilka företag du får företräda.. "),
                            _createVNode(_component_v_progress_circular, {
                              indeterminate: "",
                              color: "primary",
                              size: "18"
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (_unref(AuthStore).isAuthenticated &&
      _unref(AuthStore).permissionsLoadStatus === 'loaded' &&
      _unref(AuthStore).getSignerCompanies.length + _unref(AuthStore).getDelegates.length >
      0
      )
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(companieswithAccess)
                ]))
              : _createCommentVNode("", true),
            (_unref(AuthStore).isAuthenticated &&
      _unref(AuthStore).permissionsLoadStatus === 'loaded' &&
      _unref(AuthStore).getOtherCompanies.length > 0
      )
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(companieswithoutAccess)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["cols"]),
        _createVNode(_component_v_col, {
          cols: __props.columnSizes?.[1]
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_v_container, {
                fluid: "",
                class: "pa-7 informationBox"
              }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _hoisted_7,
                  _hoisted_8,
                  _hoisted_9,
                  _hoisted_10,
                  _hoisted_11,
                  _hoisted_12,
                  _hoisted_13
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["cols"])
      ]),
      _: 1
    })
  ]))
}
}

})